type ISubRoutingURLs = {
  [key: string]: string;
};

export const SubRoutingURLs: ISubRoutingURLs = {
  // Devitee Service
  POOJA_BOOKING_REQUEST: "Pooja Booking Request",
  REFUND: "Refund",
  POOJA_BOOKING: "Pooja Booking",
  HALL_RENTAL: "Hall Rental",
  DONATION: "Donation",
  MATCHING_DONATIONS: "Matching Donations",
  DONOR_ADVISORY_FUNDS: "Donor Advisory Funds",
  VASTRA: "Vastra",
  LADDU_OR_KARASEV_OR_VADA: "Laddu or Karasev or Vada",
  EVENT_HALL_BOOKING_REQUEST: "Event Hall Booking Request",
  MODIFY_PROFILE: "Modify Profile",
  DEVOTEE_POOJA_AND_HALL_REQUESTS: "Devotee Pooja & Hall Requests",
  MODIFY_DEVOTEE_PROFILE: "Modify Devotee Profile",
  devoteePoojaRequest: "Devotee Pooja Request",
  eventHallContractForm: "Event Hall Contract Form Request", // not implemented as of now
  CATEGORIES: "Categories", // not needed
  calendar: "Calendar", // not needed
  // Devotee Management
  REGISTER_DEVOTEE: "Register Devotee",
  DUPLICATE_DEVOTEE_RECORDS: "Duplicate Devotee Records",
  CONSOLIDATE_ACCOUNTS: "Consolidate Accounts",
  RESTORE_CONSOLIDATE_ACCOUNTS: "Restore Consolidate Accounts",
  DELETED_DEVOTEE_LIST: "Deleted Devotee List",
  QUICK_REGISTRATION: "Quick Registration",
  unSubscribe: "Unsubscribe",
  // Reports
  DEVOTEE_INFORMATION: "Devotee Information",
  DONATION_REPORT: "Donation Report",
  SPECIAL_EVENT_DONATION_REPORT: "Special Event Donation Report",
  PRIESTS_SCHEDULE_SUMMARY_CONSOLIDATED:
    "Priest's Schedule Summary - Consolidated",
  // Expense Vouchers
  EXPENSE_REQUEST: "expense-request",
  PRINT_VOUCHER: "print-voucher",
  IMPORT_BUDGETS: "import-budgets",
  VIEW_REQUESTS: "view-requests",
  UPDATE_BUDGET: "update-budget",
  ACCOUNTS: "accounts",
  ADD_SUB_ACCOUNT: "sub-account",
  CUSTOM_REPORT: "custom-report",
  EXPENSE_REPORT: "expense-report",
  APPROVED_EXPENSES: "approved-expenses",
  AUTHORIZE: "Authorize",
  // SCM Meetings
  SCM_MANAGEMENT: "scm-management",
  // Reports Section
  POOJA_REPORTS: "Pooja Reports",
  TREASURY_REPORTS: "Treasury Reports",
  PRIEST_REPORTS: "Priest Reports",
  DEVOTEE_SPONSORSHIP_REPORTS: "Devotee Sponsorship Reports",
  FRONT_DESK: "Front Desk",
  SYSTEM_REPORTS: "SystemReports",
  VOLUNTEERS:"Volunteers",
  OTHERS: "Others",
  // System settings
  DAILY_ACTIVITIES: "daily-activities",
  VASTRA_PURPOSE: "vastra-purpose",
  VASTRA_TYPES: "add-vastra",
  VASTRA_DETAILS: "vastra-details",
  DONATION_TYPES: "donation-types",
  POOJA_DETAILS: "pooja-details",
  DONATION_PURPOSE: "donation-purpose",
  EVENT_HALLS: "event-halls",
  PRIEST_SENIORITY: "priest-seniority",
  MANAGEMENT_TEAM_CATEGORIES: "managmentTeam-categories",
  // Schedules
  MY_SCHEDULE: "my-schedules",
  PRIESTS_DAILY_SCHEDULE_REPORT_FOR_CHIEF_PRIEST: "priests-daily-report",
  PRIESTS_AVAILABILITY_REPORT_FOR_CHIEF_PRIEST: "priest-availability-schedule",
  VIEW_PRIEST_SCHEDULE: "view-priest-schedule",
  VIEW_HALL_SCHEDULE: "view-hall-schedule",
  //Data Entry
  VENDORS: "data-entry",
};

export const RoutingURLs = {
  home: "/",
  dashboard: "/dashboard",
  donations: "/donations",
  register: "/register",
  user: "/user",
  changePassword: "/changepassword",
  meetingMinutes: "/meetingminutes",
  devoteeRegister: "/devoteeregister",
  login: "/login",
  managementTeam: "/mteam",
  infoPoojaItems: "/Information/poojaItems",
  awards: "/awards",
  contactInfo: "/contactinfo",
  poojaItems: "/poojaitems",
  serviceInformation: "/serviceinformation",
  religious: "/religious",
  human: "/human",
  youthAndEducation: "/youthandeducation",
  feedback: "/feedback",
  refundPolicy: "/refundPolicy",
  eventFacilities: "/eventFacilities",
  overview: "/overview",
  newsletter: "/newsletter",
  cultural: "/cultural",
  calendar: "/Calendar",
  bhajana: "/bhajana",
  faqs: "/faqs",
  creditPayment: "/creditPayment",
  check: "/check",
  aboutTemple: "/abouttemple",
  volunteer: "/volunteer",
  priests: "/priests",
  humanServices: "/humanservices",
  servicesYouthAndEducation: "/servicesyouthandeducation",
  goldenAgers: "/goldenAgers",
  educational: "/educational",
  spirtual: "/spirtual",
  health: "/health",
  funeral: "/funeral",
  retirement: "/retirement",
  inHouse: "/inhouse",
  youngAdults: "/youngadults",
  humanServicesFaqs: "/humanservicesfaqs",
  receipt: "/receipt",
  timeslots: "/timeslots",
  hallForm: "/hallForm",
  priestScheduling: "/priest-scheduling",
  devoteePoojaHallCart: "devotee-pooja-hall-cart",
};
